import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy slug — permanent redirect to the canonical EN URL. */
export const Route = createFileRoute("/cookie-policy")({
  beforeLoad: () => {
    throw redirect({ to: "/en/cookies", statusCode: 301 });
  },
});
